var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{attrs:{"fluid":"","id":"add-plant"}},[_c('b-row',{attrs:{"align-h":"center"}},[_c('p',{staticClass:"section-header"},[_vm._v("Add a plant")])]),_c('PlantForm')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }